<template>
  <div class="circles">
    <div
      v-for="(circle, index) in sizes"
      class="circle"
      :key="index"
      :style="`width: ${returnSize(index)}px; height: ${returnSize(index)}px`"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    sizes: Array,
  },

  methods: {
    returnSize(index) {
      // accumulate the array from an index, starting from the bottom
      // add the last item back (slice is untill the last item and doenst include it)
      // so the circles overlap
      const initalValue = 130;
      const last = this.sizes.slice(-1)[0];
      const arr = this.sizes.slice(index, -1).concat(last);
      const total = arr.reduce((p, c) => p + c, initalValue);
      return total;
    },
  },
};
</script>

<style scoped lang="scss">
.circle {
  position: absolute;
  background: rgba(236, 0, 77, 0.2);
  box-shadow: 0 0px 100px 0 rgba(0, 0, 0, 0.2);
  aspect-ratio: 1;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
</style>
